import React, { useState, useEffect, useContext } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import "./actors.css";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Modal,
  Button,
  IconButton,
  CardHeader,
  Divider,
  Stack,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import ActorModal from "./Modal";
import LoginAlert from "./LoginAlert";
import LoginPopup from "../auth/LoginPopup";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import "./modal.css";

import UnknownProfileImage from "../../assets/profile.jpg";

const ActorCard = ({
  actor,
  ratings,
  userRole,
  role,
  isFromSubmission,
  selectedActorsIds,
  handleActorSelectionChange,
}) => {
  const navigate = useNavigate();
  const [sliderInitialized, setSliderInitialized] = useState(false);
  const sliderRef = React.useRef(null);
  const { token, userId } = useContext(AuthContext);
  const { isAuthenticated } = useContext(AuthContext);
  const actorId = actor?.user?.id;
  const imageURL =
    actor?.user?.imageURL || actor?.profile?.imageURL || UnknownProfileImage;

  const getImagesArray = () => {
    try {
      if (
        actor?.user?.images &&
        Array.isArray(actor?.user?.images) &&
        actor?.user?.images?.length > 0
      ) {
        return actor.user.images;
      }

      if (actor?.user?.images && typeof actor?.user?.images === "string") {
        try {
          const parsed = JSON.parse(actor?.user?.images);
          if (Array.isArray(parsed) && parsed.length > 0) {
            return parsed;
          }
        } catch (e) {
          return [actor.user.images];
        }
      }

      if (
        actor?.user?.images &&
        typeof actor.user.images === "string" &&
        !actor.user.images.startsWith("[")
      ) {
        return [actor.user.images];
      }

      const fallbackImage =
        actor?.user?.imageURL ||
        actor?.profile?.imageURL ||
        UnknownProfileImage;
      return [fallbackImage];
    } catch (error) {
      return [UnknownProfileImage];
    }
  };

  const imagesArray = getImagesArray();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0);
        setSliderInitialized(true);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [imagesArray]);

  const rate = actor?.user?.rate || actor?.profile?.rate || 0;
  const firstName = actor?.user?.firstName || "Unknown";
  const lastName = actor?.user?.lastName || "Actor";
  const age = actor?.user?.age || actor?.profile?.age || " ";
  const height = actor?.profile?.height || " ";
  const weight = actor?.profile?.weight || " ";
  const hairColor = actor?.profile?.hairColor || " ";
  const eyeColor = actor?.profile?.eyeColor || " ";
  const dressSize = actor?.profile?.dressSize || " ";
  const about = actor?.profile?.about || " ";
  const hobbies = actor?.profile?.hobbies || " ";
  // const subscriptionExpire = actor.user?.subscriptionExpire;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoginAlertOpen, setIsLoginAlertOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  // Derive isSelected from selectedActorsIds prop
  const isSelected = selectedActorsIds?.includes(actorId);

  const handleViewProfile = (name, id) => {
    handleRatingClick();
    // console.log('Viewing profile', name, role);
    navigate(`/actors/${name}/${id}/actor`);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeLoginAlert = () => setIsLoginAlertOpen(false);

  const handleContactActor = () => {
    closeModal();
    setIsLoginAlertOpen(true);
  };

  const handleClickLogin = () => {
    setIsLoginOpen(true);
    closeLoginAlert();
  };

  // Remove useEffect for localStorage and toggleSelection directly updates parent state
  const toggleSelection = (e) => {
    handleActorSelectionChange(actorId, e.target.checked);
  };

  // useEffect(() => {
  //   if (subscriptionExpire) {
  //     setIsSelected(false);
  //   }
  // }, [subscriptionExpire]);

  const handleRating = async () => {
    const newRating = rate + 1;
    try {
      // const res = await updateActorRating(actor.user.id, newRating, token);
      // console.log('Token from context', token);
      const res = await axios.put(
        `https://api.opencurtainscasting.com/actor/updateRate/${actor.user.id}`,
        { rate: newRating },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.success) {
        // console.log('Rating updated successfully');
      }
    } catch (error) {
      // console.log('Error updating rating', error);
    }
  };

  let category = actor?.profile?.category || [];
  if (category) {
    if (typeof category === "string") {
      category = category.split(",").map((item) => item.trim());
    }
  }

  const handleRatingClick = () => {
    if (userId !== actor.user.id) {
      handleRating();
    }
  };

  return (
    <>
      <div className="relative" style={{ position: "relative" }}>
        {(userRole === "producer" || userRole === "director") && (
          // <Tooltip
          //   title={subscriptionExpire ? "This member has an inactive membership." : "Select actor"}
          //   arrow
          // >
          //   <span>

          <input
            type="checkbox"
            className="select-checkbox"
            checked={isSelected}
            onChange={toggleSelection}
          />
          //   </span>
          // </Tooltip>
        )}
        <Card
          sx={{
            position: "relative",
            // width: 180,
            height: 250,
            borderRadius: 1,
            overflow: "hidden",
            boxShadow: 3,
            cursor: "pointer",
            "&:hover": {
              transform: "scale(1.005)",
              transition: "0.3s ease-in-out",
            },
          }}
          onClick={openModal}
        >
          {userRole === "producer" || userRole === "director" ? (
            <div className={`actor-card ${isSelected ? "selected" : ""}`}>
              <CardMedia
                component="img"
                height="100%"
                image={imageURL}
                alt={actor.user?.firstName || "Unknown"}
                sx={{ objectFit: "cover" }}
              />
            </div>
          ) : (
            <CardMedia
              component="img"
              height="100%"
              image={imageURL}
              alt={actor.user?.firstName || "Unknown"}
              sx={{ objectFit: "cover" }}
            />
          )}
          <CardContent
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "10px",
              color: "white",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0))",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", fontSize: "16px" }}
            >
              {actor.user.firstName.charAt(0).toUpperCase() +
                actor.user.firstName.slice(1)}
            </Typography>
            {!isFromSubmission && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <FontAwesomeIcon icon={faStar} color="#6E0506" />
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  {rate}
                </Typography>
              </Box>
            )}
          </CardContent>

          <Modal
            open={isModalOpen}
            onClose={closeModal}
            BackdropProps={{
              sx: {
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                backgroundColor: "rgba(0,0,0,0.3)",
              },
            }}
          >
            {/* <Modal open={isModalOpen} onClose={closeModal}> */}
            {/* <Box
              sx={{
                display: 'flex',
                width: '50%',
                maxWidth: '900px',
                bgcolor: 'background.paper',
                borderRadius: 3,
                overflow: 'hidden',
                mx: 'auto',
                mt: 5,
                color: '#6e0506',
              }}
            > */}
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",

                display: "flex",
                width: {
                  xs: "95%",
                  sm: "90%",
                  md: "80%",
                  lg: "50%",
                },

                bgcolor: "background.paper",
                borderRadius: 3,
                overflow: "hidden",
              }}
            >
              <Card
                sx={{
                  color: "#6e0506",
                  display: "flex",
                  width: "100%",
                  postion: "relative",
                }}
              >
                {/* <CardMedia
                  component='img'
                  sx={{ width: '40%', height: 400 }}
                  image={imageURL}
                  alt={`${firstName} ${lastName}`}
                /> */}
                <Box
                  sx={{ width: "40%", height: "400px", position: "relative" }}
                >
                  <Slider
                    className="custom-dots-slider"
                    dots={true}
                    infinite={true}
                    speed={500}
                    slidesToShow={1}
                    slidesToScroll={1}
                    autoplay={true}
                    autoplaySpeed={3000}
                    arrows={false}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    {imagesArray.map((image, index) => (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          height: "400px",
                          padding: "0px",
                        }}
                      >
                        <CardMedia
                          component="img"
                          image={image}
                          alt={actor.user?.firstName || "Unknown"}
                          sx={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "60%",
                    color: "#6e0506",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <CardHeader
                      title={`${
                        firstName.charAt(0).toUpperCase() + firstName.slice(1)
                      } ${
                        lastName.charAt(0).toUpperCase() + lastName.slice(1)
                      }`}
                      titleTypographyProps={{
                        sx: {
                          fontSize: {
                            xs: "20px",
                            sm: "29px",
                            md: "30px",
                          },
                          fontWeight: 600,
                        },
                      }}
                      subheader={
                        <Box display="flex" alignItems="center">
                          <FontAwesomeIcon icon={faStar} color="#6E0506" />
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "14px", marginLeft: "4px" }}
                          >
                            {rate}
                          </Typography>
                        </Box>
                      }
                    />

                    <IconButton
                      className="actor-modal-close"
                      onClick={(e) => {
                        e.stopPropagation();
                        closeModal();
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  <Divider />
                  <CardContent
                    sx={{
                      flex: "1 0 auto",
                      height: "200px",
                      overflowY: "scroll",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    <Stack spacing={2}>
                      <Typography variant="body1">
                        <strong>Age:</strong> {age} y.o.
                      </Typography>
                      <Typography id="category">
                        <strong>Job Titles:</strong>{" "}
                        {category && category.length > 0
                          ? category.join(", ")
                          : "N/A"}
                      </Typography>

                      {actor?.profile?.location && (
                        <Typography id="location">
                          <strong>Location:</strong>{" "}
                          {actor?.profile?.location
                            ? actor?.profile?.location
                            : "N/A"}
                        </Typography>
                      )}
                      <Typography variant="body1">
                        <strong>Appearance:</strong> <br />
                        {height} Height | {weight} Weight | {hairColor} Hair |{" "}
                        {eyeColor} Eyes
                      </Typography>
                      <Typography variant="body1">
                        <strong>About:</strong> <br />
                        {about}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Hobbies:</strong> <br />
                        {hobbies}
                      </Typography>
                    </Stack>
                  </CardContent>

                  <Divider />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      gap: 1,
                      p: 2,
                    }}
                  >
                    {!isAuthenticated && (
                      <Button
                        startIcon={<ContactPageIcon />}
                        variant="contained"
                        color="secondary"
                        onClick={handleContactActor}
                      >
                        Contact Talent
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AssignmentIndIcon />}
                      onClick={() =>
                        handleViewProfile(firstName, actor?.user?.id)
                      }
                      sx={{
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        padding: {
                          xs: "6px 10px",
                          sm: "8px 14px",
                          md: "10px 18px",
                        },
                      }}
                    >
                      View Full Profile
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Modal>
          <LoginAlert
            isLoginAlertOpen={isLoginAlertOpen}
            closeAlert={closeLoginAlert}
            handleClickLogin={handleClickLogin}
          />
          <LoginPopup
            isLoginOpen={isLoginOpen}
            setIsLoginOpen={setIsLoginOpen}
          />
        </Card>
      </div>
    </>
  );
};

export default ActorCard;
